export default __webpack_public_path__ + "content/media/27.bc26ecce.jpg";